<template>
  <app-content class="h-panel">
    <div class="h-panel-bar">
      <span class="h-panel-title">现金及现金等价物科目范围</span>
      <div class="h-panel-right">
        <Button color="primary" @click="addSubject">添加科目</Button>
        <Button @click="reload" :loading="loading">刷新</Button>
      </div>
    </div>
    <div class="h-panel-body">
      <Alert type="info">
        <strong>说明：</strong>现金及现金等价物科目用于识别现金流量表中的现金流入和流出。
        系统默认包含库存现金（1001）、银行存款（1002）和其他货币资金（1012）及其下级科目。
        您可以根据实际情况调整科目范围。
      </Alert>

      <Table :datas="subjects" :loading="loading" stripe border>
        <TableItem title="科目编码" prop="subjectCode" :width="150"></TableItem>
        <TableItem title="科目名称" prop="subjectName" :width="250"></TableItem>
        <TableItem title="状态" :width="100">
          <template slot-scope="{data}">
            <span :class="data.enabled ? 'text-success' : 'text-muted'">
              {{ data.enabled ? '启用' : '禁用' }}
            </span>
          </template>
        </TableItem>
        <TableItem title="操作" :width="150" align="center">
          <template slot-scope="{data}">
            <Button size="small" color="error" @click="removeSubject(data)">移除</Button>
          </template>
        </TableItem>
      </Table>

      <Modal v-model="addModal.visible" title="添加现金科目" :width="500">
        <Form :label-width="100">
          <FormItem label="选择科目">
            <Select v-model="addModal.selectedSubjectId" :datas="availableSubjects" filterable placeholder="请选择科目"></Select>
          </FormItem>
        </Form>
        <div slot="footer">
          <Button @click="addModal.visible = false">取消</Button>
          <Button color="primary" @click="doAddSubject" :loading="addModal.loading">添加</Button>
        </div>
      </Modal>
    </div>
  </app-content>
</template>

<script>
export default {
  name: 'CashFlowSubjects',
  data() {
    return {
      loading: false,
      subjects: [],
      allSubjects: [],
      addModal: {
        visible: false,
        selectedSubjectId: null,
        loading: false
      }
    };
  },
  computed: {
    availableSubjects() {
      const existingIds = this.subjects.map(s => s.subjectId);
      return this.allSubjects
        .filter(s => !existingIds.includes(s.id))
        .map(s => ({
          value: s.id,
          label: `${s.code} ${s.name}`
        }));
    }
  },
  created() {
    this.reload();
    this.loadAllSubjects();
  },
  methods: {
    async reload() {
      this.loading = true;
      try {
        const res = await this.$api.cashflow.cashSubjects.list();
        if (res.success) {
          this.subjects = res.data || [];
        } else {
          this.$Message.error(res.msg || '加载失败');
        }
      } catch (e) {
        console.error('加载现金科目失败', e);
        this.$Message.error('加载失败');
      } finally {
        this.loading = false;
      }
    },
    async loadAllSubjects() {
      try {
        const res = await this.$api.setting.subject.list('资产');
        if (res.success) {
          this.allSubjects = this.flattenSubjects(res.data || []);
        }
      } catch (e) {
        console.error('加载科目列表失败', e);
      }
    },
    flattenSubjects(subjects) {
      const result = [];
      const flatten = (list) => {
        for (const s of list) {
          result.push(s);
          if (s.children && s.children.length > 0) {
            flatten(s.children);
          }
        }
      };
      flatten(subjects);
      return result;
    },
    addSubject() {
      this.addModal.selectedSubjectId = null;
      this.addModal.visible = true;
    },
    async doAddSubject() {
      if (!this.addModal.selectedSubjectId) {
        this.$Message.warning('请选择科目');
        return;
      }

      this.addModal.loading = true;
      try {
        const subjectIds = [...this.subjects.map(s => s.subjectId), this.addModal.selectedSubjectId];
        const res = await this.$api.cashflow.cashSubjects.update(subjectIds);
        if (res.success) {
          this.$Message.success('添加成功，现金科目范围已更新');
          this.$Message.info('自动分类结果已失效，请到现金流量表页面重新查询以触发重算');
          this.addModal.visible = false;
          this.reload();
        } else {
          this.$Message.error(res.msg || '添加失败');
        }
      } catch (e) {
        console.error('添加科目失败', e);
        this.$Message.error('添加失败');
      } finally {
        this.addModal.loading = false;
      }
    },
    removeSubject(subject) {
      this.$Modal.confirm({
        title: '确认移除',
        content: `确定要移除科目 "${subject.subjectCode} ${subject.subjectName}" 吗？`,
        onOk: async () => {
          try {
            const subjectIds = this.subjects
              .filter(s => s.subjectId !== subject.subjectId)
              .map(s => s.subjectId);
            const res = await this.$api.cashflow.cashSubjects.update(subjectIds);
            if (res.success) {
              this.$Message.success('移除成功，现金科目范围已更新');
              this.$Message.info('自动分类结果已失效，请到现金流量表页面重新查询以触发重算');
              this.reload();
            } else {
              this.$Message.error(res.msg || '移除失败');
            }
          } catch (e) {
            console.error('移除科目失败', e);
            this.$Message.error('移除失败');
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.text-success {
  color: #19be6b;
}
.text-muted {
  color: #999;
}
</style>
